module.exports = __webpack_public_path__ + "components/country-flag/static/gh-40f345528555b326c1fb20784d829a50.svg";